import {Component, OnInit, ViewChild} from '@angular/core';
import {ContatosService} from "../services/contatos.service";
import {BuscarContatoComponent} from "../componentes/buscar-contato/buscar-contato.component";
import {NgForm} from "@angular/forms";
import * as locale from "../locale/calendar-ptbr";
import {ModalKendo} from "../lib/ModalKendo";
import {DataHoraUtils} from "../lib/DataHoraUtils";
import {ConstantsService} from "../fidelidade/ConstantsService";

@Component({
  selector: 'app-novo-contato',
  templateUrl: './novo-contato.component.html',
  styleUrls: ['./novo-contato.component.scss']
})
export class NovoContatoComponent extends ModalKendo implements OnInit {
  @ViewChild('frm', {static: true})  frm: NgForm;
  @ViewChild('buscarContatoComponent', {static: true}) buscarContatoComponent: BuscarContatoComponent;
  mensagemSucesso: string ;
  mensagemErro: string ;
  salvando: boolean  ;
  contato: any;
  ptBr: any;
  dataNascimento: Date;
  exibirEmail;
  agora: Date;
  moduloFiadoAtivo = false;
  constructor( private contatosService: ContatosService,
               private constantsService: ConstantsService ) {
    super()
    this.agora  = new Date();
  }

  ngOnInit() {
    this.contato = this.contato || {};
    this.ptBr = locale.ptBR
    this.constantsService.moduloFiado$.subscribe((ativo: boolean) => {
      this.moduloFiadoAtivo = ativo === true;
      if(!this.moduloFiadoAtivo && this.contato?.contaFinanceira)
        this.contato.contaFinanceira.ativo = false;
    });
    if(!this.contato)
      this.contato = {};
    this.garantaContaFinanceira();
    this.exibirEmail = this.contato.email != null;
  }

  exibaContato(contato: any) {
    this.contato = Object.assign({}, contato);
    this.garantaContaFinanceira();
    if(this.contato.dataNascimento)
        this.contato.dataNascimento = DataHoraUtils.obtenhaDataDaString(this.contato.dataNascimento);

    this.buscarContatoComponent.exibaContato(this.contato);
  }

  onSubmit() {
    delete   this.mensagemErro;
    this.buscarContatoComponent.valide();

    if ( !this.frm.valid )
      return;

    this.contato.telefone = this.buscarContatoComponent.obtenhaTelefone();
    this.contato.codigoPais = this.buscarContatoComponent.obtenhaCodigoPais();

    this.contatosService.salveContato(this.contato).then( (resp) => {
      this.mensagemSucesso = 'Contato atualizado com sucesso!';
      const contatoSalvo = Object.assign({}, this.contato, resp || {});
      if (resp && resp.id) {
        contatoSalvo.id = resp.id;
      }
      this.fecheModal(contatoSalvo)
    }).catch( (erro) => {
      this.salvando = false;
      this.mensagemErro = erro;
    });
  }

  fecheMensagemSucesso() {
    this.mensagemSucesso = null;
  }

  private garantaContaFinanceira() {
    if(!this.contato.contaFinanceira)
      this.contato.contaFinanceira = {
        ativo: this.contato.permiteFiadoLoja === true
      };

    this.contato.contaFinanceira.permiteFiado = this.contato.contaFinanceira.permiteFiado === true;
    this.contato.contaFinanceira.ativo = this.contato.contaFinanceira.ativo === true;
    if(this.contato.contaFinanceira.limiteFiado === '')
      this.contato.contaFinanceira.limiteFiado = null;
  }
}
